import {
  ExternalCalendarEvent,
  ExternalCalendarEventPreview,
  ID,
} from '@griply/types';

import { getExternalCalendarEventPreview } from './get-external-calendar-event-preview';

export type ExternalEventInteractionHandles = {
  url?: string;
  connectionId?: ID;
  calendarId?: ID;
  isOrganizer?: boolean;
  preview?: ExternalCalendarEventPreview;
};

// A pending create's id is a local placeholder, so every handle interactions resolve through is withheld.
export const getExternalEventInteractionHandles = (
  externalEvent: ExternalCalendarEvent,
): ExternalEventInteractionHandles => {
  if (externalEvent.pending) {
    return {};
  }

  return {
    url: externalEvent.url,
    connectionId: externalEvent.connectionId,
    calendarId: externalEvent.calendarId,
    isOrganizer: externalEvent.isOrganizer,
    preview: getExternalCalendarEventPreview(externalEvent),
  };
};
